import {
  Component,
  OnInit,
  Inject,
  Optional,
  HostListener,
  ViewChild,
  computed,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { NgForm, UntypedFormControl } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { defer, forkJoin, Observable, of } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
import { IApiResult } from "src/app/shared/models/apiresult.interface";
import { DataService } from "src/app/data.service";
import { AuthService } from "src/app/auth.service";
import { db, qService } from "src/app/db.service";
import { SnapshotService, IMaterialDelta } from "src/app/snapshot.service";
import { IProduction } from "src/app/shared/models/production.interface";
import { v4 as uuidv4 } from "uuid";

import * as _moment from "moment";
const moment = _moment;
import "lodash";
import { ITransaction } from "src/app/shared/models/transaction.interface";
import { NewFormulaDialogComponent } from "src/app/dialogs/formula-dialog/formula-dialog.component";
import { PusherService } from "src/app/pusher.service";
import { ProductsService } from "../products.service";
import { NewMaterialDialogComponent } from "src/app/dialogs/material-dialog/material-dialog.component";
import { NewProductDialogComponent } from "src/app/dialogs/product-dialog/product-dialog.component";
declare var _: any;

@Component({
  selector: "app-add-istehsal-dialog",
  templateUrl: "./add-istehsal-dialog.component.html",
  styleUrls: ["./add-istehsal-dialog.component.css"],
})
export class AddIstehsalDialogComponent implements OnInit {
  @ViewChild("inv") form: NgForm;
  date;
  dateNow = moment(Date.now()).format("YYYY-MM-DD");
  personnel;
  selectedPersonnelId: number;
  stock: {}[] = [];
  selectedFormulaGroupId;
  selectedStockGroupId: number =
    this._dataService.stockGroups().find((s) => s.type == 2)?.id || 1;
  machineNo;
  length;
  lengthPlaceholder;
  weight;
  weightPlaceholder;
  quantity;
  width;
  widthPlaceholder;
  showWidth: boolean = false;
  formulaTableData = [];
  formulaDisplayedColumns: string[] = ["material", "quantity", "unit"];
  formulaTotalQuantity;
  deleteTransaction = of({});
  selectedFormulaName: string = null;
  dataLoading: boolean = false;
  usedMaterials: { [key: string]: any }[] = [];
  usedProducts: {}[] = [];
  usedProductsWithQty = [];
  formulaTotalWeight: number = 0;
  response;
  user: string;

  colDefs = [
    {
      headerName: "id",
      field: "id",
      hide: true,
    },
    {
      headerName: "Mehsul",
      field: "materialId",
      sortable: true,
      flex: 1,
      cellRenderer: (params) => {
        return (
          this._dataService.materials().find((c) => c.id == params.value)
            ?.name || ""
        );
      },
    },
    {
      headerName: "Miqdar",
      field: "quantity",
      sortable: true,
      flex: 1,
      cellRenderer: (params) => {
        return params.value ? params.value.toFixed(3) : "-";
      },
    },
    {
      headerName: "Formul",
      field: "formulaQuantity",
      sortable: true,
      flex: 1,
      cellRenderer: (params) => {
        return params.value ? params.value.toFixed(3) : "-";
      },
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<AddIstehsalDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialog: MatDialog,
    private http: HttpClient,
    private toastr: ToastrService,
    public _dataService: DataService,
    public _authService: AuthService,
    protected _productService: ProductsService,
    private _pusher: PusherService,
    private _snapshotService: SnapshotService
  ) {}

  @HostListener("keydown.enter", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    if (this.form.valid && this.form.controls.machineNo.value) {
      this.addNewIstehsal(this.form.value, event);
    }
  }

  ngOnInit(): void {
    this.date =
      this._dataService.startDate?.value.format("YYYY-MM-DD") ==
      this._dataService.endDate?.value.format("YYYY-MM-DD")
        ? new UntypedFormControl(
            moment(this._dataService.endDate?.value.format("YYYY-MM-DD"))
          )
        : new UntypedFormControl(moment());

    this.personnel = computed(() => {
      return this._dataService.customers().filter(function (el) {
        return el.customerGroupId == 3;
      });
    });

    if (this.dialogData) {
      this.date = new UntypedFormControl(moment(this.dialogData.date));
      this.selectedPersonnelId = this.dialogData.customerId;
      this.quantity = this.dialogData.quantity;
      this.weight = this.dialogData.weight;
      this.length = this.dialogData.length;
      this.width = this.dialogData.width;
      this.machineNo = this.dialogData.machineNo;
      this.selectedFormulaGroupId = this.dialogData.formulaGroupId;
      this._productService.selectedProductId = this.dialogData.productId;
      this.selectedFormulaName = this.dialogData.formulaGroupId
        ? _.find(this._dataService.formulaGroups(), {
            id: this.dialogData.formulaGroupId,
          }).name
        : null;
      this.showWidth =
        this._dataService
          .products()
          .filter((t) => t.id == this._productService.selectedProductId)[0]
          ?.unit == "m2"
          ? true
          : false;

      if (this.dialogData?.transactionId?.userId) {
        let userName = this._dataService
          .users()
          .find((u) => u.id == this.dialogData?.transactionId?.userId);
        this.user = userName ? userName.fullname : null;
      }
    } else {
      this._productService.selectedProductId = null;
    }

    if (this._productService.selectedProductId) {
      this.lengthPlaceholder = _.find(this._dataService.products(), {
        id: this._productService.selectedProductId,
      }).length;
      this.weightPlaceholder = _.find(this._dataService.products(), {
        id: this._productService.selectedProductId,
      }).weight;
      this.widthPlaceholder = _.find(this._dataService.products(), {
        id: this._productService.selectedProductId,
      }).width;
    }

    if (!this.dialogData?.formulaGroupId) {
      this.formulaDisplayedColumns.splice(2, 1);
    }
  }

  getProducts(): Observable<any> {
    return this.http
      .get<IApiResult>(this._dataService.dbBase + "api.php/records/products")
      .pipe(
        map((res) => {
          return res.records;
        })
      );
  }

  async addNewIstehsal(data, event, remove?) {
    const registration = await navigator.serviceWorker.ready;

    if ("sync" in registration) {
      // Background sync is available - proceed with offline-first approach
      event.target.innerText = "Saxlanılır...";
      event.target.disabled = true;
      let queueRequestId = null;

      // 1. Generate temporary, unique IDs for local use
      const tempTransactionId = uuidv4();
      const tempProductionId = uuidv4();
      const tempStockIds = [];
      const tempUsedProductIds = [];

      const today = moment();
      this.date = new UntypedFormControl(moment());
      this.date.value = data.date;

      // 2. Prepare the transaction object
      const transaction = {
        id: tempTransactionId,
        type: "Production",
        customerId: data.personnelId,
        date: this.date.value.format("YYYY-MM-DD"),
        dateAdded: today.format("YYYY-MM-DD HH:mm:ss"),
        details: "Istehsalat",
        userId: this._authService.loggedInUserValue.id ?? null,
        syncStatus: "pending",
      };

      // 3. Prepare the main production entry
      const newIstehsal = {
        id: tempProductionId,
        transactionId: transaction,
        tId: tempTransactionId,
        productId: data.productId,
        quantity: data.quantity,
        weight: data.weight,
        length: data.length,
        width: data.width,
        productionType: "Production",
        customerId: data.personnelId,
        machineNo: data.machineNo,
        formulaGroupId: this.selectedFormulaGroupId,
        formulaTotalWeight: this.formulaTotalWeight,
        date: transaction.date,
        syncStatus: "pending",
      };

      // 4. Prepare stock entries and used products
      let stockEntries = [];
      let usedProductsWithQty = [];
      let formulaGroup = null;

      try {
        await (registration as any).sync.register("test-sync");
        // Get formula group if needed
        if (this.selectedFormulaGroupId) {
          formulaGroup = await db.formulaGroups.get(
            this.selectedFormulaGroupId
          );
          await this.getUsedMaterials(formulaGroup.formulas);
        }

        // Process used materials for stock entries
        this.usedMaterials?.forEach((element) => {
          if (element.materialId) {
            let usedMaterialQuantity = null;
            const material = _.find(this._dataService.materials(), {
              id: element.materialId,
            });

            switch (material.unit) {
              case "ədəd": {
                usedMaterialQuantity = -parseFloat(
                  newIstehsal.quantity.toFixed(5)
                );
                break;
              }
              case "m": {
                usedMaterialQuantity = -parseFloat(
                  (newIstehsal.quantity / data.length).toFixed(5)
                );
                break;
              }
              case "m2": {
                usedMaterialQuantity = -parseFloat(
                  (newIstehsal.quantity / data.length).toFixed(5)
                );
                break;
              }
              default: {
                usedMaterialQuantity = -parseFloat(
                  (
                    (element.quantity / this.formulaTotalWeight) *
                    data.weight *
                    data.quantity *
                    data.length
                  ).toFixed(5)
                );
                break;
              }
            }

            const tempStockId = uuidv4();
            tempStockIds.push(tempStockId);

            stockEntries.push({
              id: tempStockId,
              transactionId: transaction,
              tId: tempTransactionId,
              materialId: element.materialId,
              quantity: usedMaterialQuantity,
              price: material.price,
              stockGroupId: this.selectedStockGroupId,
              date: transaction.date,
              customerId: transaction.customerId,
              tType: transaction.type,
              syncStatus: "pending",
            });
          }
        });

        // NEW: Create deltas for snapshot system (parallel to stock entries)
        const materialDeltas: IMaterialDelta[] = stockEntries.map(entry => ({
          materialId: entry.materialId,
          stockGroupId: entry.stockGroupId,
          date: entry.date,
          quantityChange: entry.quantity,
          sourceType: 'production' as const,
          sourceId: tempTransactionId,
          isProduction: true
        }));

        // Process used products
        if (this.usedProducts.length) {
          this.usedProducts.forEach((element: any) => {
            if (element?.productId) {
              const tempUsedProductId = uuidv4();
              tempUsedProductIds.push(tempUsedProductId);

              usedProductsWithQty.push({
                id: tempUsedProductId,
                transactionId: transaction,
                tId: tempTransactionId,
                productId: element.productId,
                quantity: -newIstehsal.quantity,
                formulaGroupId: null,
                weight: this._dataService
                  .products()
                  .find((p) => p.id == element.productId).weight,
                length: data.length,
                width: data.width,
                productionType: "İstehsalat",
                customerId: data.personnelId,
                machineNo: data.machineNo,
                formulaTotalWeight: this.formulaTotalWeight,
                date: transaction.date,
                syncStatus: "pending",
              });
            }
          });
        }

        // 5. Prepare the payload for background sync queue
        const queuePayload = {
          type: "ADD_PRODUCTION",
          payload: {
            transaction: {
              ...transaction,
              id: undefined,
              syncStatus: undefined,
            },
            production: {
              ...newIstehsal,
              id: undefined,
              syncStatus: undefined,
            },
            stockEntries: stockEntries.map((entry) => ({
              ...entry,
              id: undefined,
              syncStatus: undefined,
            })),
            usedProducts: usedProductsWithQty.map((entry) => ({
              ...entry,
              id: undefined,
              syncStatus: undefined,
            })),
            productUpdate: {
              productId: data.productId,
              weight: data.weight,
              length: data.length,
              width: data.width,
              formulaGroupId: this.selectedFormulaGroupId,
            },
          },
          context: {
            tempTransactionId,
            tempProductionId,
            tempStockIds,
            tempUsedProductIds,
            removeTransactionId: remove ? this.dialogData.tId : null,
            dbName: this._dataService.dbTable,
          },
        };

        // 6. Save everything to Dexie and the queue
        await db.transaction(
          "rw",
          db.transactions,
          db.production,
          db.stock,
          db.materialDeltas,
          async () => {
            await db.transactions.add(transaction);
            await db.production.add(newIstehsal);

            if (stockEntries.length > 0) {
              await db.stock.bulkAdd(stockEntries);
            }

            // NEW: Add deltas for snapshot system
            if (materialDeltas.length > 0) {
              await db.materialDeltas.bulkAdd(materialDeltas);
              
              // CRITICAL: Rebuild snapshots for affected materials/months
              const affectedMonths = new Map<string, { materialId: number; stockGroupId: number; yearMonth: string }>();
              
              materialDeltas.forEach(delta => {
                const yearMonth = delta.date.substring(0, 7);
                const key = `${delta.materialId}_${delta.stockGroupId}_${yearMonth}`;
                
                if (!affectedMonths.has(key)) {
                  affectedMonths.set(key, {
                    materialId: delta.materialId,
                    stockGroupId: delta.stockGroupId,
                    yearMonth: yearMonth
                  });
                }
              });
              
              // Rebuild each affected month's snapshot
              for (const data of affectedMonths.values()) {
                await this._snapshotService.rebuildMonthSnapshot(
                  data.materialId,
                  data.stockGroupId,
                  data.yearMonth
                );
              }
            }

            if (usedProductsWithQty.length > 0) {
              await db.production.bulkAdd(usedProductsWithQty);
            }

            // Remove old entries if this is an update
            if (remove && this.dialogData.tId) {
              await db.transactions.delete(this.dialogData.tId);
              await db.production
                .where("tId")
                .equals(this.dialogData.tId)
                .delete();
              await db.stock.where("tId").equals(this.dialogData.tId).delete();
              
              // NEW: Remove old deltas and rebuild snapshots
              await this._snapshotService.deleteDeltasForTransaction(this.dialogData.tId);
            }
          }
        );

        // Store the queue request ID for potential cleanup
        queueRequestId = await qService.requests.add({
          payload: queuePayload,
          timestamp: Date.now(),
        });

        // 7. Register the background sync task
        await (registration as any).sync.register("app-sync");

        // 8. Give immediate success feedback
        this.dialogRef.close("reload");
        this.toastr.success("", "Əlavə edildi!", {
          toastClass: "ngx-toastr customToast",
          progressBar: true,
          timeOut: 2500,
          progressAnimation: "increasing",
        });
      } catch (error) {
        this.postOnlineProduction(data, event, remove);
      }
    } else {
      this.postOnlineProduction(data, event, remove);
    }
  }

  // Separate the original logic into a postOnlineProduction method
  postOnlineProduction(data, event, remove?) {
    event.target.innerText = "Gözləyin ...";
    event.target.disabled = true;
    this.date = new UntypedFormControl(moment());
    let today = new UntypedFormControl(moment());
    this.date.value = data.date;
    let newIstehsal: IProduction;

    const handleError = () => {
      event.target.innerText = "Əlavə et";
      event.target.disabled = false;
      this.toastr.error("", "Xəta baş verdi, yenidən cəhd edin", {
        toastClass: "ngx-toastr",
        progressBar: true,
        timeOut: 2500,
        progressAnimation: "increasing",
      });
    };

    let formulaGroupId = this.selectedFormulaGroupId;

    let getFormulaGroup = formulaGroupId
      ? this.http.get<IApiResult>(
          `${this._dataService.dbBase}api.php/records/formulaGroups/${formulaGroupId}?join=formulas&join=materials`
        )
      : of(null);

    let deleteOldFormula = remove
      ? this.http.delete(
          this._dataService.dbBase +
            "api.php/records/transactions/" +
            this.dialogData.tId
        )
      : of(null);

    let transaction: ITransaction = {
      type: "Production",
      customerId: data.personnelId,
      date: this.date.value.format("YYYY-MM-DD"),
      dateAdded: today.value.format("YYYY-MM-DD HH:mm:ss"),
      details: "Istehsalat",
      userId: this._authService.loggedInUserValue.id ?? null,
    };

    newIstehsal = {
      transactionId: null,
      productId: data.productId,
      quantity: data.quantity,
      weight: data.weight,
      length: data.length,
      width: data.width,
      productionType: "İstehsalat",
      customerId: data.personnelId,
      machineNo: data.machineNo,
      formulaGroupId: formulaGroupId,
      formulaTotalWeight: this.formulaTotalWeight,
    };

    // Rest of the original forkJoin logic remains the same...
    forkJoin([
      getFormulaGroup,
      this.http.post<number>(
        this._dataService.dbBase + "api.php/records/transactions",
        transaction
      ),
    ])
      .pipe(
        switchMap((r) =>
          defer(() =>
            r[0] ? this.getUsedMaterials(r[0].formulas) : of(null)
          ).pipe(
            map(() => {
              transaction.id = r[1];
              newIstehsal.transactionId = r[1];

              this.deleteTransaction = this.http.delete(
                this._dataService.dbBase +
                  "api.php/records/transactions/" +
                  r[1]
              );

              this.usedMaterials?.forEach((element) => {
                let usedMaterialQuantity = null;

                if (element.materialId) {
                  switch (
                    _.find(this._dataService.materials(), {
                      id: element.materialId,
                    }).unit
                  ) {
                    case "ədəd": {
                      usedMaterialQuantity = -parseFloat(
                        newIstehsal.quantity.toFixed(5)
                      );
                      break;
                    }
                    case "m": {
                      usedMaterialQuantity = -parseFloat(
                        (newIstehsal.quantity / data.length).toFixed(5)
                      );
                      break;
                    }
                    case "m2": {
                      usedMaterialQuantity = -parseFloat(
                        (newIstehsal.quantity / data.length).toFixed(5)
                      );
                      break;
                    }
                    default: {
                      usedMaterialQuantity = -parseFloat(
                        (
                          (element.quantity / this.formulaTotalWeight) *
                          data.weight *
                          data.quantity *
                          data.length
                        ).toFixed(5)
                      );
                      break;
                    }
                  }

                  this.stock.push({
                    transactionId: r[1],
                    materialId: element.materialId ? element.materialId : null,
                    quantity: usedMaterialQuantity,
                    price: element.materialId
                      ? _.find(this._dataService.materials(), {
                          id: element.materialId,
                        }).price
                      : null,
                    stockGroupId: this.selectedStockGroupId,
                  });
                }
              });

              if (this.usedProducts.length) {
                this.usedProducts.forEach((element: any) => {
                  if (element?.productId) {
                    this.usedProductsWithQty.push({
                      ...newIstehsal,
                      productId: element.productId,
                      quantity: -newIstehsal.quantity,
                      formulaGroupId: null,
                      weight: this._dataService
                        .products()
                        .find((p) => p.id == element.productId).weight,
                    });
                  }
                });
              }
            })
          )
        ),
        switchMap(() =>
          forkJoin({
            production: this.http.post(
              this._dataService.dbBase + "api.php/records/production",
              [newIstehsal, ...this.usedProductsWithQty]
            ),
            stock: this.http.post(
              this._dataService.dbBase + "api.php/records/stock",
              this.stock
            ),
            productUpdate: this.http.put(
              this._dataService.dbBase +
                "api.php/records/products/" +
                data.productId,
              {
                weight: data.weight,
                length: data.length,
                width: data.width,
                formulaGroupId: this.selectedFormulaGroupId,
              }
            ),
            deleteOldFormula: deleteOldFormula,
          })
        ),
        tap((res) => {
          this.response = res;
        })
      )
      .subscribe({
        error: (e) => {
          forkJoin({
            deleteTransaction: this.deleteTransaction,
            storeErrorInDatabase: this._dataService.storeErrorInDatabase(
              e,
              JSON.stringify(transaction),
              JSON.stringify(newIstehsal),
              JSON.stringify(data),
              "Istehsal"
            ),
          }).subscribe({
            complete: handleError,
            error: handleError,
          });
        },
        complete: () => {
          let dbProduction = {
            ...newIstehsal,
            id: this.response.production[0],
            tId: transaction.id,
            date: transaction.date,
            transactionId: transaction,
          };
          let dbStock = [];
          this.stock?.forEach((el, i) => {
            dbStock.push({
              ...el,
              id: this.response.stock[i],
              tId: transaction.id,
              transactionId: transaction,
              date: transaction.date,
              customerId: transaction.customerId,
              tType: transaction.type,
            });
          });
          if (remove) {
            db.transactions.delete(this.dialogData.tId);
            db.production.where("tId").equals(this.dialogData.tId).delete();
            db.stock.where("tId").equals(this.dialogData.tId).delete();
          }
          db.transactions.add(transaction, transaction.id);
          db.production.add(dbProduction, dbProduction.id);
          db.stock.bulkAdd(dbStock);
          this._pusher.postData("New Production").subscribe();
          this.dialogRef.close("reload");
          this.toastr.success("", "Əlavə edildi!", {
            toastClass: "ngx-toastr customToast",
            progressBar: true,
            timeOut: 2500,
            progressAnimation: "increasing",
          });
        },
      });
  }

  getUsedMaterials = async (obj, parentMultiplier = 1) => {
    for (const f of obj) {
      if (f.materialId != null) {
        // Create a copy of the formula item with adjusted quantity
        const adjustedFormula = {
          ...f,
          quantity: f.quantity * parentMultiplier,
        };

        this.usedMaterials.push(adjustedFormula);

        if (
          _.find(this._dataService.materials(), { id: f.materialId }).unit ==
          "kg"
        ) {
          this.formulaTotalWeight =
            this.formulaTotalWeight + adjustedFormula.quantity;
        }
      }

      if (f.productId != null) {
        // Apply parent multiplier to product quantities as well
        const adjustedProduct = {
          ...f,
          quantity: f.quantity * parentMultiplier,
        };
        this.usedProducts.push(adjustedProduct);
      }

      if (f.includedFormulaGroupId != null) {
        let result = await this.getFormulaGroup(f.includedFormulaGroupId);
        let totalQuantity = 0;

        // Calculate total quantity in the nested formula
        result.formulas?.forEach((element) => {
          totalQuantity += element.quantity;
        });

        // Normalize quantities to ratios and apply the parent formula's quantity
        result.formulas?.forEach((element) => {
          element.quantity =
            (element.quantity / totalQuantity) * f.quantity * parentMultiplier;
        });

        // Recursively process the nested formula with multiplier = 1
        // (since we already applied the multiplier above)
        await this.getUsedMaterials(result.formulas, 1);
      }
    }

    return this.usedMaterials;
  };

  // THIS SHOWS USED MATERIALS IN THE QAIME
  async getProductionFormula() {
    let formula = await db.formulaGroups.get(this.dialogData.formulaGroupId);
    await this.getUsedMaterials(formula.formulas);

    this.formulaTableData = [];
    this.usedMaterials?.forEach((element) => {
      let usedMaterialQuantity = null;

      if (element.materialId) {
        switch (
          _.find(this._dataService.materials(), {
            id: element.materialId,
          }).unit
        ) {
          case "ədəd": {
            usedMaterialQuantity = parseFloat(
              this.dialogData.quantity.toFixed(5)
            );
            break;
          }
          case "m": {
            usedMaterialQuantity = parseFloat(
              (this.dialogData.quantity / this.dialogData.length).toFixed(5)
            );
            break;
          }
          case "m2": {
            usedMaterialQuantity = parseFloat(
              (this.dialogData.quantity / this.dialogData.length).toFixed(5)
            );
            break;
          }
          default: {
            usedMaterialQuantity = parseFloat(
              (
                (element.quantity / this.formulaTotalWeight) *
                this.dialogData.weight *
                this.dialogData.quantity *
                this.dialogData.length
              ).toFixed(5)
            );
            break;
          }
        }

        this.formulaTableData.push({
          materialId: element.materialId ? element.materialId : null,
          quantity: usedMaterialQuantity,
          price: element.materialId
            ? _.find(this._dataService.materials(), {
                id: element.materialId,
              }).price
            : null,
          stockGroupId: this.selectedStockGroupId,
          formulaQuantity: element.quantity,
        });
      }
    });
    // this.dataLoading = true;
    // let stocks = await db.stock
    //   .where("tId")
    //   .equals(this.dialogData.tId)
    //   .toArray();
    // stocks = stocks.map((item) => ({
    //   ...item,
    //   materialId: this._dataService
    //     .materials()
    //     .find((m) => m.id == item.materialId),
    // }));
    // let prods = (
    //   await db.production.where("tId").equals(this.dialogData.tId).toArray()
    // ).filter((p) => p.quantity < 0);
    // prods = prods.map((item) => ({
    //   ...item,
    //   materialId: this._dataService
    //     .products()
    //     .find((m) => m.id == item.productId),
    // }));
    // let res = [...stocks, ...prods];

    // this.formulaTableData.data = res;

    // this.formulaTotalQuantity = this._dataService
    //   .formulaGroups()
    //   .find((f) => f.id == this.dialogData.formulaGroupId)
    //   ?.formulas.map((t) => t.quantity)
    //   .reduce((acc, value) => acc + value, 0);
    // this.dataLoading = false;
  }

  exportInvoice(data) {
    console.log(data);
  }

  async getFormulaGroup(id: number) {
    let result = await db.formulaGroups.get(id);
    return result;
  }

  productSelected() {
    const selectedProduct = _.find(this._dataService.products(), {
      id: this._productService.selectedProductId,
    });
    this.selectedFormulaGroupId = this._productService.selectedProductId
      ? selectedProduct.formulaGroupId
      : null;
    this.length = this._productService.selectedProductId
      ? selectedProduct.length
      : null;
    this.lengthPlaceholder = this._productService.selectedProductId
      ? selectedProduct.length
      : null;
    this.weightPlaceholder = this._productService.selectedProductId
      ? selectedProduct.weight
      : null;
    this.widthPlaceholder = this._productService.selectedProductId
      ? selectedProduct.width
      : null;
    this.width = this._productService.selectedProductId
      ? selectedProduct.width
      : null;
    this.showWidth =
      this._productService.selectedProductId && selectedProduct.unit === "m2";
    this.weight = this._productService.selectedProductId
      ? selectedProduct.weight
      : null;
  }

  newFormulaDialog(formulaId?: number, uzleme?: string) {
    let dialogRef;
    let data = { formulaId: formulaId, uzleme: uzleme };
    dialogRef = this.dialog.open(NewFormulaDialogComponent, {
      width: "900px",
      data: data,
      panelClass: "materialDialog",
      closeOnNavigation: true,
      disableClose: this._dataService.mobileDevice
        ? false
        : formulaId
        ? false
        : true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this._dataService.getFormulaGroups().subscribe((r) => {
          this._dataService.formulaGroups.set(r);
          localStorage.setItem("formulaGroups", JSON.stringify(r));
        });
      }
    });
  }

  onRowClick(row, i) {
    console.log(row);
    let data = null;
    if (row.productId) {
      data = this._dataService.products().find((x) => x.id == row.productId);
      this.dialog.open(NewProductDialogComponent, {
        width: "750px",
        data: data,
        panelClass: "materialDialog",
      });
      return;
    } else if (row.materialId.id) {
      data = this._dataService
        .materials()
        .find((x) => x.id == row.materialId.id);
    }
    this.dialog.open(NewMaterialDialogComponent, {
      width: "750px",
      data: data,
      panelClass: "materialDialog",
    });
  }
}
